export default {
    login: {
        "intelligentIoTManagementPlatform": "智慧公寓管理系统",
        "Username": "用户名",
        "Password": "密码",
        "code": "验证码",
        "login": "登录",
        "pleaseEnterUsername": "请输入用户名",
        "pleaseEnterPassword": "请输入密码",
        "pleaseEnterCode": "请输入验证码",
        "nickname": "昵称",
        "Loginaccount": "登录账号",
        "superadministrator": "超级管理员",
        "Salesman": "业务员",
        "user": "用户"
    },
    home: {
        "Numberofusers": "使用人数",
        "Invalidated": "作废",
        "mandatoryDistribution": "强制下发",
        "total": '终端总数',
        "deviceTotal": '设备总数',
        "SmartLock": '智能门锁',
        "Bindingquantity": "绑定数量",
        "OfflineDevices": '离线设备',
        "AbnormalDevices": '异常设备',
        "FaultyDevice": '故障设备',
        "OnlineDevice": '在线设备',
        "dataStatisticsAnalysis": "数据统计分析",
        "oneClickAlarm": "一键报警",
        "infraredAlarm": "红外报警",
        "totalDeviceAlarms": "设备报警总数",
        "Numberofalarms": "报警数量",
        "Lowbatteryquantity": "低电数量",
        "vacantRestroom": "蹲位空闲",
        "manholeCoverAnomaly": "井盖异常",
        "totalEnergyConsumption": "总用电",
        "totalWaterConsumption": "总用水",
        "overflowingTrashBin": "垃圾桶满溢",
        "poorAirQuality": "空气质量差",
        "temperatureHumidityAnomaly": "温湿度异常",
        "times": "次",
        "pieces": "个",
        "grasp": "把",
        "peoples": "人",
        "lockOpenTimes": "一周开锁次数",
        "businessManagementData": "业务管理数据",
        "totalNumberOfUsers": "总用户",
        "totalNumberOfRooms": "房间总数",
        "TotalNumberOfLocksOpendToday": "今日开锁总数",
        "totalUnlockingTimes": "开锁总次数",
        "totalNumberOfDeviceAlarms": "设备报警总数",
        "numberOfDoorsOpened": "门开数量",
        "numberOfDoorsClosed": "门关数量",
        "totalRechargeAmount": "总充值金额",
        "weeklyNewDevices": "新增设备",
        "devicePowerAnalysis": "设备电量分析",
        "powerLevel": "电量",
        "numbs": "数量",
        "trillion": "万亿",
        "Billion": "亿",
        "tenThousand": "万",
        "doorLockOverview": "门锁概况",
        "lateReturnCount": "晚归人数",
        "totalProjectCount": "项目总数",
        "LateReturnees": "晚归人员",
        "totalRoomCount": "房间总数",
        "totalUserCount": "用户总数",
        "totalUnlockCount": "开锁总数",
        "usedDoorLocks": "使用门锁",
        "unusedDoorLocks": "未使用门锁",
        "lowBatteryWarning": "低电量警告",
        "fingerprintErrorWarning": "指纹试错警告",
        "passwordErrorWarning": "密码试错警告",
        "passwordUnlock": "密码开锁",
        "fingerprintUnlock": "指纹开锁",
        "Mechanicalkeyunlocking": "机械钥匙开锁",
        "nfcUnlock": "NFC开锁",
        "bluetoothUnlock": "蓝牙开锁",
        "keyUnlock": "钥匙开锁",
        "idCardUnlock": "身份证开锁",
        "NBunlocking": "NB开锁",
        "Unlockthenumerickeypad": "数字键盘开锁",
        "unlockRecords": "开锁记录",
        "fingerprint": "指纹",
        "digitalKeypad": "数字键盘",
        "mechanicalKey": "机械钥匙",
        "bluetooth": "蓝牙",
        "idCard": "身份证",
        "pinCode": "单机密码",
        "face": "人脸",
        "device": "设备号",
        "name": "姓名",
        "userTelephone": "账号",
        "roomName": "房间名",
        "Devicestatus": "设备状态",
        "openType": "开锁方式",
        "checkInStatisticsAnalysis": "入住统计分析",
        "unlockCountStatistics": "当天时间区间开锁次数统计图",
        "LockPlatform": "锁平台",
        "Equipmenttype": "设备类型",
        "AlarmLog": "告警日志",
        "Wirelesskeyunlocking": "无线钥匙开锁",
        "Faceunlock": "人脸开锁",
        "Offlinecardunlocking": "离线卡开锁",
        "Offlinepasswordunlocking": "离线密码开锁",
        "Otherunlocking": "其它开锁",
        "SynchronizeUpdates": "同步更新",
        "Numberofalarmstoday": "今日告警次数"
    },
    room: {
        "campus": '校区',
        "roomManagement": "房间管理",
        "voucherManagement": "凭证管理",
        "exportListing": "导出房源"
    },
    checkIn: {
        "":"",
        "certificateName":"凭证",
        "remarkText249": "分区项目总数",
        "Currentpartition": "当前分区",
        "Modifypermission": "修改权限",
        "personnelTermination": "人员退租",
        "personnelLeaseExtension": "人员续租",
        "roomSelection": "房源选择",
        "personnelRegistration": "人员登记",
        "voucherEntry": "录入凭证",
        "addPersonnelInfoToRoom": "房间添加人员信息",
        "nextStep": "下一步",
        "occupiedPersonnelInfo": "已入住人员信息",
        "name": "姓名",
        "campusCardNo": "卡号",
        "physicalCardNo": "物理卡号",
        "identity": "身份",
        "department": "所属部门",
        "checkInTime": "入住时间",
        "checkOutTime": "退租时间",
        "gender": "性别",
        "malefemale": "1为男，2为女",
        "NFCPassword": "3为NFC,4为密码",
        "remark": "备注",
        "phoneNumber": "手机号",
        "digitphonenumber": "为11位手机号",
        "leaseTerm": "租期",
        "operation": "操作",
        "personnelVoucher": "人员录入凭证",
        "enteredVoucherInfo": "已录入凭证信息",
        "pendingVoucher": "待下发凭证",
        "roomNumber": "所属房间",
        "terminationOfLease": "退租",
        "room": "房间",
        "systemNumber": "系统编号",
        "idCard": "身份证号",
        "startTime": "开始日期",
        "endTime": "结束日期",
        "allRooms": "全部房间",
        "guests": "入住人员",
        "numberOfVouchers": "凭证数量",
        "noShow": "未入住",
        "normal": "正常",
        "reportthelossof": "挂失",
        "preaccountopening": "预开户",
        "expire": "过期",
        "company": "企业",
        "remarkText": "*每行数据颜色背景标注：1、绿色背景代表该凭证对应下发指令都下发成功 2、黄色代表该凭证对应下发指令有下发中指令 3、红色代表该凭证对应下发指令有下发失败指令",
        "pleaseselectanidentity": "请选择身份",
        "remarkText2": "为11位唯一识别,如:20220810104",
        "bindRoom": "绑定房间",
        "batchRenew": "批量续租",
        "batchCheckout": "批量退租",
        "issueVoucher": "下发凭证",
        "serialNumber": "序号",
        "studentID": "工号",
        "cardnumber": "卡号",
        "male": "男",
        "female": "女",
        "doorcardstatus": "门卡状态",
        "cardstatus": "卡状态",
        "pleaseselect": "请选择",
        "createanaccount": "创建账号",
        "vouchername": "凭证名称",
        "SelectStartDateTime": "选择开始日期时间",
        "SelectEndDateTime": "选择结束日期时间",
        "freeze": "冻结",
        "noneroom": "暂无房源",
        "peoplename": "人员名称",
        "to": "至",
        "Selectabindingroom": "选择绑定房间",
        "unbind": "解除绑定",
        "renewaloflease": "续租",
        "addavoucher": "添加凭证",
        "selectthetype": "请选择类型",
        "vouchertype": "凭证类型",
        "VoucherValidity": "凭证有效期",
        "createdtime": "创建时间",
        "batchissuance": "批量下发",
        "ModifyVoucher": "修改凭证",
        "distributionrecord": "查看下发记录",
        "Deleteplatformrecords": "删除平台记录",
        "type": "类型",
        "Uploadphotos": "上传照片",
        "leftthumb": "左手大拇指",
        "rightindexfinger": "右手食指",
        "leftindexfinger": "左手食指",
        "rightthumb": "右手大拇指",
        "CollectingFingerprintsZH": "GX1000-zh采集指纹",
        "CollectingFingerprintsLWJ": "LWJ采集指纹",
        "enterthecontent": "请输入内容",
        "NFCcardnumber": "NFC卡号",
        "enterthedevicenumber": "请输入设备号",
        "entertheIMEInumber": "请输入IMEI号",
        "selectthecorrespondingroom": "请选择对应房间",
        "selectthedistributionstatus": "请选择下发状态",
        "Issuedsuccessfully": "下发成功",
        "Waittosend": "等待发送",
        "Issuing": "下发中",
        "Sendingfailed": "发送失败",
        "Invalidated": "已作废",
        "Lockendcredentialtype": "锁端凭证类型",
        "lockendcertificate": "锁端凭证有效期",
        "Distributionstatus": "下发状态",
        "Reissue": "重新下发",
        "batchupload": "批量上传",
        "ImportExcel": "导入EXCEL",
        "DownloadTemplate": "下载模板",
        "Checkinroom": "入住房间",
        "Thecontent": "内容",
        "ThecontentNFCpassword": "NFC为8位16进制物理卡号、密码为6位数字密码",
        "periodofvalidity": "有效期",
        "enteryourname": "请输入姓名",
        "remarkText3": "最小时间不能小于或大于这个时间范围",
        "selectthevouchertype": "请选择凭证类型",
        "enterthevouchername": "请输入凭证名称",
        "pleaseenter": "请输入",
        "Other": "其它",
        "Freezeuser": "冻结用户",
        "remarkText4": "是否冻结该锁用户?",
        "remarkText5": "是否解冻该锁用户?",
        "remarkText6": "是否冻结这些锁用户?",
        "remarkText7": "是否解冻这些锁用户?",
        "remarkText8": "是否退租?",
        "remarkText9": "此操作将延长入住时间, 是否继续?",
        "remarkText10": "请选择时间范围",
        "remarkText11": "暂未发现对应设备",
        "remarkText12": "确定要删除平台记录吗?",
        "remarkText13": "此操作将删除锁上凭证，请确认！",
        "remarkText14": "暂无发现对应指纹序号",
        "remarkText15": "未找到对应设备",
        "remarkText16": "获取房间对应门锁信息失败",
        "remarkText17": "删除人员对应凭证成功",
        "remarkText18": "删除人员对应凭证失败",
        "remarkText19": "请勾选需要删除的数据",
        "remarkText20": "确定要删除吗？",
        "remarkText21": "是否续住?",
        "remarkText22": "该房间未绑定门锁",
        "remarkText23": "请选择要添加的房间",
        "remarkText24": "用户门锁已存在",
        "remarkText25": "卡格式错误，请重新录入",
        "remarkText26": "密码不能为空",
        "remarkText27": "是否先退租已入住房间？",
        "remarkText28": "请填写完整信息",
        "remarkText29": "请填写正确手机号",
        "remarkText30": "创建账号成功",
        "remarkText31": "创建账号失败",
        "remarkText32": "请选择所属部门",
        "remarkText33": "请选择指纹别名",
        "remarkText34": "密码长度为6位",
        "remarkText35": "确定要重新下发吗？",
        "remarkText36": "未发现这个设备",
        "remarkText37": "是否只解除平台关系，不删除锁上用户？",
        "remarkText38": "写卡错误，请检查读卡器是否正常！",
        "remarkText39": "读卡错误，请检查读卡器是否正常！",
        "remarkText40": "该房间正在下发此用户,不能删除！",
        "remarkText41": "删除用户成功",
        "remarkText42": "删除用户失败",
        "remarkText43": "解绑房间成功",
        "remarkText44": "解绑房间失败",
        "remarkText45": "未找到对应锁上凭证记录",
        "remarkText46": "卡格式错误，是否删除重新录入",
        "remarkText47": "未找到锁上对应凭证ID",
        "remarkText48": "此操作将删除凭证记录，请确认！",
        "remarkText49": "请先删除锁上凭证",
        "remarkText50": "格式错误",
        "remarkText51": "批量不支持指纹",
        "remarkText52": "该房间未找到对应门锁",
        "tips": "提示",
        "Freezinginstruction": "冻结指令",
        "thawinginstruction": "解冻指令",
        "Failedtoissue": "下发失败",
        "Issuingtimeout": "下发超时",
        "selectthestartandendtime": "请选择开始结束时间",
        "Freezeandlockusers": "批量解冻锁用户",
        "Modificationfailed": "修改失败",
        "Modificationsuccessful": "修改成功",
        "alreadyexists": "已存在",
        "Deletingsuccessfully": "删除成功",
        "Failedtodelete": "删除失败",
        "Deleting": "删除中",
        "Undermodification": "修改中",
        "Studentcardinformation": "学生卡信息",
        "Addingfailed": "添加失败",
        "Addingsuccessfully": "添加成功",
        "Operationsuccessful": '操作成功',
        "Operationfailed": "操作失败",
        "Unbindsuccessfully": "解绑成功",
        "Unbindfailed": "解绑失败",
        "PersonnelImportTemplate": "人员导入模板",
        "Bindingsuccessful": "绑定成功",
        "Bindingfailed": "绑定失败",
        "Removed": "删除了",
        "unknown": "未知",
        "offline": "离线",
        "online": "在线",
        "abnormal": "异常",
        "search": "搜索",
        "DeviceName": "设备名称",
        "whole": "全部",
        "Expired": "已过期",
        "uninitialized": "未初始化",
        "initialization": "初始化",
        "BindingStatus": '绑定状态',
        "Bound": "已绑定",
        "Unbound": "未绑定",
        "Versionnumber": "版本号",
        "remarkText53": "选设备上线开始时间",
        "SelectEndTime": "选择结束时间",
        "signal": "信号",
        "Doorlockoperation": "门锁操作",
        "Temporarypassword": "临时密码",
        "Remoteunlocking": "远程开锁",
        "Removeallpasswords": "删除所有密码",
        "DeleteallNFCs": "删除所有NFC",
        "DeleteallFps": "删除所有指纹",
        "Resetdoorlock": "重置门锁",
        "empty": "空",
        "signalintensity": "信号强度",
        "gateway":"网关",
        "Onlinestatus": "在线状态",
        "Registrationtime": "注册时间",
        "Launchtime": "上线时间",
        "Remoteunlockingpassword": "远程开锁密码",
        "Administratorpassword": "管理员密码",
        "model": "型号",
        "SupertubeID": "超管ID",
      "IMSI": "IMSI",
        "Operator": "运营商",
        "SupertubeName": "超管名称",
        "Supertubepassword": "超管密码",
        "Customercode": "客户码",
        "Connectionmethod": "连接方式",
        "Directconnection": "直连",
        "SelectRoom": "选择房间",
        "Deviceverificationcode": "设备验证码",
        "Doorlockdetails": "门锁详情",
        "volume": '音量',
        "Mute": "静音",
        "bass": "低音",
        "Treble": "高音",
        "Normallyopensetting": "常开设置",
        "Normallyopenstate": "常开状态",
        "Datasynchronization": "数据同步",
        "Selectstarttimeperiod": "选择开始时间段",
        "SelectEndTimePeriod": "选择结束时间段",
        "ConfirmSettings": "确认设置",
        "Unset": "取消设置",
        "StartingMonth": "开始月份",
        "EndMonth": "结束月份",
        "Operationlog": "操作日志",
        "VoucherRecord": "凭证记录",
        "BatchSetNormallyOpen": "批量常开设置",
        "Starttimeperiod": "开始时间段",
        "Endtimeperiod": "结束时间段",
        "MACaddress": "MAC地址",
        "Appbindingnumber": "APP绑定号",
        "Productionwritenumber": "生产写入号",
        "remarkText54": "紧急密码，每天仅能用一次",
        "remarkText55": "门锁近期信号曲线",
        "remarkText56": "门锁近期电量曲线",
        "signalcurve": "信号曲线",
        "Time": "时间",
        "doorlocksignal": "门锁信号",
        "electricitycurve": "电量曲线",
        "Doorlockpower": "门锁电量",
        "today": "今天",
        "Lastweek": "最近一周",
        "Thismonth": "本月",
        "Thisyearsofar": "今年至今",
        "Lastsixmonths": "最近六个月",
        "Close": "关",
        "Inthemiddle": "中",
        "Highly": "高",
        "Telecommunications": "电信",
        "Move": "移动",
        "Unicom": "联通",
        "Listofdoorlocks": "门锁列表",
        "Dataerror": "数据错误",
        "remarkText57": "是否解冻该门锁?",
        "remarkText58": "是否冻结该门锁?",
        "Resetsuccessfully": "重置成功",
        "Initializationsucceeded": "初始化成功",
        "Initializationfailed": "初始化失败",
        "remarkText59": "是否确认数据同步?",
        "Nodataavailable": "暂无数据",
        "remarkText60": "该房间已绑定锁，请重新选择",
        "Sentsuccessfully": "发送成功",
        "Acquisitionsucceeded": "获取成功",
        "Failedtoobtain": "获取失败",
        "remarkText61": "请勾选要批量添加的设备",
        "Setsuccessfully": "设置成功",
        "Settingfailed": "设置失败",
        "remarkText62": "请选择正确的开始时间段",
        "remarkText63": "请选择正确的结束时间段",
        "remarkText64": "该类型锁不支持此设置！",
        "Open": "开",
        "remarkText65": "是否确认重置门锁?",
        "remarkText66": "确定要删除所有卡吗？",
        "remarkText661": "确定要删除所有指纹吗？",
        "remarkText67": "确定要删除所有密码吗？",
        "remarkText68": "确定要远程开门吗？",
        "remarkText69": "开锁成功!",
        "remarkText70": "开锁失败!",
        "remarkText71": "请选择初始化设备",
        "remarkText72": "确定要批量初始化吗？",
        "remarkText73": "确定要初始化吗？",
        "remarkText74": "注册成功",
        "remarkText75": "注册失败，请稍后再试",
        "remarkText76": "确定要批量远程开锁吗？",
        "remarkText77": "确定要解绑吗？",
        "remarkText78": "设备导入模板",
        "Eachpage": '每页',
        "strip": "条",
        "AddAccount": "添加账户",
        "Adddepartment": "添加部门",
        "HistoricalAccount": "历史账户",
        "Usertype": "用户类型",
        "role": '角色',
        "Changepassword": "修改密码",
        "Oldpassword": "旧密码",
        "Newpassword": "新密码",
        "Createdepartment": "创建部门",
        "Affiliatedinstitution": "所属机构",
        "Departmentname": "部门名称",
        "Allowaccess": "允许接入",
        "coordinate": "坐标",
        "Editingdepartment": '编辑部门',
        "ModifyName": "修改名称",
        "housingresources": "房源",
        "selectaddress": "选择地址",
        "Lockpryingalarm": '撬锁报警',
        "Forceddooropeningalarm": "强行开门报警",
        "Lowbatteryalarm": "低电量报警",
        "Duressunlockingalarm": "胁迫开锁报警",
        "RechargeSMS": "充值短信",
        "Successfullypaidtherent": "交租成功",
        "Remindertopayrent": "提醒交租",
        "Successfullysignedthecontract": "签约成功",
        "SeniorAdministrator": "高级管理员",
        "Intermediateadministrator": "中级管理员",
        "Lowleveladministrator": "低级管理员",
        "administrators": "管理员",
        "Subusers": "子用户",
        "AppletUser": "小程序用户",
        "Name": '名称',
        "remarkText79": "长度为 11 个字符",
        "remarkText80": "确定要删除部门对应账号吗？",
        "Accountdeletedsuccessfully": '账号删除成功',
        "Accountdeletionfailed": "账号删除失败",
        "remarkText81": "请选择要编辑的部门",
        "remarkText82": "请输入允许接入设备数量",
        "Createdsuccessfully": "创建成功",
        "Creationfailed": "创建失败",
        "Exceedingquota": "超出配额",
        "remarkText83": "确认密码输入错误！",
        "remarkText84": "请输入修改的密码",
        "AddRole": "添加角色",
        "rolename": "角色名称",
        "classification": "分类",
        "SaveSettings": '保存设置',
        "Defaultpermissions": "默认权限",
        "yes": "是",
        "no": "否",
        "Option1": "选项1",
        "Option2": "选项2",
        "Updatesuccessful": "更新成功",
        "Updatefailed": "更新失败",
        "DefaultRole": "默认角色",
        "Operationmodule": "操作模块",
        "Operationpath": "操作路径",
        "Requesttype": "请求类型",
        "Operationdescription": "操作描述",
        "Operationmethod": "操作方法",
        "Requestparameters": "请求参数",
        "Returnparameters": "返回参数",
        "Requestpath": "请求路径",
        "Operationtime": "操作时间",
        "Detailedinformation": "详情",
        "Exceptionlog": "异常日志",
        "Errormessage": "错误信息",
        "Wrongname": "错误名称",
        "Alarmtype": "报警类型",
        "Alarmtime": "报警时间",
        "Dooropeningmethod": "开门方式",
        "remarkText85": "门卡试错开锁",
        "Unlockingtime": "开锁时间",
        "remarkText86": "数据大于10000条，无法导出",
        "Setpersonnel": "设置人员",
        "SetStatus": "设置状态",
        "Settime": "设置时间",
        "remarkText87": "日期范围",
        "remarkText88": "时间段",
        "Lockuser": "锁用户",
        "Operatorpersonal": "操作员",
        "Operationtype": "操作类型",
        "CommandStatus": "命令状态",
        "serialnumber": "流水号",
        "remarkText89": "未发现对应门锁，操作失败",
        "remarkText90": "未发现对应凭证记录，操作失败",
        "remarkText91": "是否重新下发！",
        "remarkText92": "请输入校区名称",
        "remarkText93": "请选择具体地址",
        "remarkText94": "入住人数",
        "remarkText300": "是否强制下发！",
        "Address": "地址",
        "Typeofapartment": "户型",
        "singleroom": "单间",
        "room1": "一室一厅",
        "room2": "两室一厅",
        "room3": "三室一厅",
        "Area": "面积",
      "codeNumber": "编号",
        "tenant": "租户",
        "remarkText95": "单个创建",
        "remarkText96": "请输入数字",
        "Sorting": "排序",
      "remarkText999": "编号",
        "isRoom": "是否为房间",
        "Templatecreation": "模板创建",
        "Levelname": "层级名称",
        "remarkText97": "例如：宿舍区、宿舍楼、 楼栋单元、楼层、房间，多个以‘、’隔开",
        "Numberoflevels": "层级数量",
        "remarkText98": "请输入对应层级数量，多个以‘、’隔开",
        "Singleaddition": "单个添加",
        "TemplateAddition": "模板添加",
        "FloorLevel": "楼层",
        "remarkText99": "请输入对应楼层的房间数",
        "Numberofrooms": "房间数量",
        "remarkText100": "请输入公寓名称",
        "Addhierarchy": "添加层级",
        "Addroom": "添加房间",
        "binding": "绑定",
        "BindUser": "绑定用户",
        "Unbind": "解绑",
        "remarkText101": "请选择需要导出的房源",
        "Apartment1": "公寓1",
        "Apartment2": "公寓2",
        "Building1": "1号楼",
        "Building2": "2号楼",
        "Unit1": "1单元",
        "Unit2": "2单元",
        "1stfloor": "1楼",
        "2ndfloor": "2楼",
        "remarkText102": "删除后人员和设备的关系都会删除，确定要删除吗？",
        "remarkText103": "房间未绑定门锁",
        "Dormitorysources": "宿舍房源",
        "Housinginformation": "房源信息",
        "remarkText104": "已到第一级",
        "remarkText105": "房间不能添加下级",
        "remarkText106": "请勾选需要解绑的数据",
        "remarkText107": "请勾选需要管理的数据",
        "remarkText108": "确定要绑定吗？",
        "remarkText109": "公寓名称不能为空",
        "remarkText110": "公寓单元名称不能为空",
        "remarkText111": "公寓层数不能为空",
        "remarkText112": "公寓单元和层数数量需要对应",
        "remarkText113": "楼层名称不能为空",
        "remarkText114": "房间数不能为空",
        "remarkText115": "请选择凭证状态",
        "Bluetoothbuckle": "蓝牙扣",
        "remarkText116": "未发现对应设备",
        "remarkText117": "查询设备失败",
        "remarkText118": "两次密码输入不一致！",
        "remarkText119": "请选择删除数据！",
        "remarkText120": "是否删除平台凭证！",
        "remarkText121": "该凭还未下发",
        "remarkText122": "删除锁与平台记录",
        "remarkText123": "门锁被撬",
        "remarkText124": "强行开门",
        "remarkText125": "指纹尝试开锁被冻结",
        "remarkText126": "密码尝试开锁被冻结",
        "remarkText127": "卡尝试开锁被冻结",
        "remarkText128": "钥匙尝试开锁被冻结",
        "remarkText129": "低电量报警",
        "remarkText130": "保留",
        "remarkText131": "胁迫开锁报警",
        "remarkText132": "忘拔钥匙",
        "remarkText133": "敲门提醒",
        "remarkText134": "SOS求救提醒",
        "remarkText135": "门没关好",
        "remarkText136": "门已反锁",
        "remarkText137": "门已解锁",
        "remarkText138": "常开已开启",
        "remarkText139": "其它报警",
        "remarkText140": "电量低压提醒",
        "Canceledsuccessfully": "取消成功",
        "Cancelfailed": "取消失败",
        "Totalincome": "总收入",
        "Totalnumberofpeople": "总人数",
        "Signed": "已签约",
        "Totalnumberofresidentialareas": "总小区数",
        "Totalnumberofrooms": "总房间数",
        "NumberofOccupations": "已入住数",
        "Roominarrears": "欠费房间",
        "Totalequipment": "总设备",
        "Totalnumberofexceptions": "异常数",
        "Lowbatterycount": "低电数",
        "expiredequipment": '到期设备',
        "roomoccupancyrate": "房间入住率",
        "rateofarrearsinroomcharges": "房间欠费率",
        "Checkininformation": "今日开锁",
        "月": "month",
        "Rentalincomeranking": "租金收入排行榜（￥）",
        "remarkText141": "选择入住日期时间",
        "remarkText142": "选择退租日期时间",
        "Selectdevice": "选择设备",
        "Finished": "完成",
        "Entering": "录入",
        "capturecardZH": "GX1000-zh采集卡",
        "Setpassword": "设置密码",
        "Confirmpassword": "确认密码",
        "remarkText143": "请输入姓名搜索",
        "remarkText144": "请输入学号",
        "remarkText145": "该身份证已存在",
        "remarkText146": "该NFC已存在",
        "remarkText147": "该密码已存在",
        "remarkText148": "该指纹已存在",
        "remarkText149": "请选择下发凭证",
        "remarkText150": "此操作将下发所选凭证, 是否继续?",
        "remarkText151": "已取消下发",
        "remarkText152": "该门锁已离线，请先处理门锁离线问题！",
        "remarkText153": "请选择开始和结束时间",
        "remarkText154": "身份证号不能为空",
        "remarkText155": "NFC不能为空",
        "remarkText156": "密码不能为空",
        "remarkText157": "请录入指纹",
        "remarkText158": "两次输入的密码不一致，请重新输入！",
        "Submittedsuccessfully": "提交成功",
        "remarkText159": "请选择房间",
        "remarkText160": "请选择凭证",
        "remarkText161": "请先绑定门锁",
        "remarkText162": "获取该门锁凭证失败",
        "remarkText163": "请选择入住和退租时间",
        "remarkText164": "请先绑定设备",
        "remarkText165": "此人员已存在",
        "Checkin": "入住",
        "remarkText166": "长度在 1 到 8 个字符",
        "remarkText167": "请输入正确的系统编号",
        "remarkText168": "请输入正确的身份证号",
        "remarkText169": "请选择学历",
        "remarkText170": "请输入邮箱",
        "remarkText171": "请输入正确的邮箱",
        "remarkText172": "请选择租期时间",
        "remarkText173": "请输入租金",
        "remarkText174": "请选择退租人员",
        "remarkText175": "确定要退租吗？",
        "remarkText176": "退租成功",
        "remarkText177": "退租失败",
        "Leaseterminated": "退租中",
        "remarkText178": "请筛选是否过期",
        "Normalroom": "正常房间",
        "vacantroom": "空置房间",
        "thaw": "解冻",
        "Freezepersonnel": "冻结人员",
        "remarkText179": "请选择解冻人员",
        "remarkText180": "确定要解冻吗？",
        "remarkText181": "确定要冻结吗？",
        "Unitname": "单位名称",
        "remarkText182": "请选择所属单位",
        "remarkText183": "请输入联系人姓名",
        "remarkText184": "请输入联系人电话",
        "Noticemethod": "通知方式",
        "Subordinateunit": "所属单位",
        "textmessage": "短信",
        "officialaccount": "公众号",
        "QuickActions": "快捷操作",
        "Allocationquota": "分配额度",
        "Existinglimit": "现有额度",
        "Allocableamount": "可分配额度",
        "Policecall": "接警电话",
        "Receivingtype": "接收类型",
        "remarkText185": "设备未处理报警记录",
        "remarkText247": "切换单个/多个查询模式",
        "Assignedsuccessfully": "分配成功",
        "balance": "余额不足",
        "remarkText186": "是否确认修改？",
        "remarkText187": "名称不能为空",
        "remarkText188": "手机号不能为空",
        "generate": "生成",
        "Callbacktype": "回调类型",
        "CallbackURL": "回调URL",
        "Userdatacallback": "用户数据回调",
        "Callbackofhousingdata": "房源数据回调",
        "apartment": "公寓",
        "PingshanVillage": "平山村",
        "remarkText189": "各小区房间数量（间）",
        "remarkText190": "新增房间数（间）",
        "remarkText191": "新增房间数",
        "Tobesigned": "待签约",
        "Arrears": "已欠费",
        "withdrawaloflease": "已退租",
        "Numberofcontracts": "合同数",
        "hasexpired": "已到期",
        "Signingstatus": "签约状态",
        "remarkText192": "最低租金",
        "remarkText193": "最高租金",
        "Signacontract": "签约",
        "ContractNo": "合同编号",
        "Rent": "租金/￥",
        "ContractStatus": "合约状态",
        "Deleted": "已删除",
        "CreatedDate": "创建日期",
        "Freezeuserpermission": "冻结用户权限",
        "Previewcontract": "预览合同",
        "remarkText194": "填写签约人信息",
        "Certificatetype": "证件类型",
        "CertificateNo": "证件号",
        "nativeplace": "籍贯",
        "Addressforcorrespondence": "通讯地址",
        "TenantCategory": "租户类别",
        "Subsidystandard": "补贴标准",
        "Addcoresident": "添加同住人",
        "Information": "信息",
        "Deletethecohabitant": "删除同住人",
        "remarkText195": "查找房源信息",
        "remarkText196": "房屋地址信息",
        "Monthlyrent": "月租金",
        "remarkText197": "房屋结构信息",
        "RoomStatus": "房间状态",
        "remarkText198": "填写合约信息",
        "remarkText199": "所选房间",
        "remarkText200": "套内房间数量",
        "Signatory": "签约人",
        "Passport": "护照",
        "Paymentmethod": "支付方式",
        "Signingtime": "签约时间",
        "remarkText201": "合同签约时间",
        "remarkText202": "合同有效时间",
        "Effectivetime": "生效时间",
        "Paymentdate": "缴费日期",
        "remarkText203": "是否发送动态临时密码",
        "remarkText204": "录入开锁授权",
        "remarkText205": "是否是常开卡",
        "remarkText206": "时效密码",
        "Lastmonth": "最近一个月",
        "Lastthreemonths": "最近三个月",
        "Cashmoney": "现金",
        "Creditcard": "刷卡",
        "Alipay": "支付宝",
        "WeChat": "微信",
        "remarkText207": "一次性补贴",
        "remarkText208": "按月补贴",
        "remarkText209": "一次性补贴+按月基本补贴",
        "remarkText210": "中国大陆",
        "remarkText211": "港澳台同胞",
        "remarkText212": "国际友人",
        "remarkText213": "开始时间不得大于结束时间",
        "tenancycontract": "房屋租赁合同",
        "Syncsuccessful": "同步成功",
        "Synchronizationfailed": "同步失败",
        "remarkText214": "是否先进行删除操作？",
        "remarkText215": "请选择支付方式",
        "remarkText216": "请输入合同编号",
        "remarkText217": "请选择缴费时间",
        "remarkText218": "请选择签约时间",
        "remarkText219": "请选择有效期",
        "remarkText220": "请选择人员",
        "remarkText221": "请选择录入凭证类型",
        "remarkText222": "通知成功",
        "remarkText223": "通知失败",
        "remarkText224": "该人员已有合约，请重新选择",
        "remarkText225": "同住人员有重复的表单信息，请填写正确表单信息",
        "remarkText226": "请正确填写签约人表单信息",
        "remarkText227": "该房间还未绑定设备，请绑定设备后进行入住",
        "remarkText228": "手机格式错误",
        "remarkText229": "身份证号错误",
        "remarkText230": "未找到人员",
        "remarkText231": "开始时间和结束时间不能为空",
        "remarkText232": "开始时间不能超出祖约时间",
        "remarkText233": "结束时间不能超出租约时间",
        "remarkText234": "该凭证已保存",
        "remarkText235": "该凭证已存在",
        "remarkText236": "请选择批量删除合约",
        "remarkText237": "是否先进行批量删除？",
        "remarkText238": "请选择批量退租合约",
        "remarkText239": "是否先进行批量退租？",
        "remarkText240": "是否先进行退租？",
        "remarkText241": "没有找到对应房间信息",
        "remarkText242": "创建模板",
        "remarkText243": "模板名称",
        "filename": "文件名称",
        "TemplateContent": "模板内容",
        "remarkText244": "此操作将删除该模板, 是否继续?",
        "Uploadsuccessful": "上传成功",
        "Uploadfailed": "上传失败",
        "remarkText245": "房屋租赁合同模板",
        "remarkText246": "请选择续租人员",
        "Renewalsuccessful": "续租成功",
        "Renewalfailed": "续租失败",
        "remarkText250": '今日新增设备数',
        "remarkText248": "当前分区设备占比",
        "demonstrate": "演示",
        "remarkText251": "设备号不能为空",
        "remarkText252": "该锁未绑定房间，请先绑定房间",
        "remarkText253": "请先选择人员",
        "remarkText254": "绑定人员成功",
        "remarkText255": "绑定人员失败",
        "remarkText256": "下发凭证成功",
        "remarkText257": "下发凭证失败",
        "remarkText258": "确认关闭?"
    },
    button: {
        "Exportcontract": "导出合同",
        "Synchronizecontractstatus": "同步合约状态",
        "Newlyadded": "新增",
        "query": "查询",
        "reset": "重置",
        "add": "添加",
        "Update": "更新",
        "modify": "修改",
        "cancel": "取消",
        "back": "返回",
        "view": "查看",
        "addSubordinate": "添加下级",
        "edit": "编辑",
        "delete": "删除",
        "export": "导出",
        "batchDelete": "批量删除",
        "doorLock": "门锁",
        "tenant": "住户",
        "confirm": "确认",
        "selectAll": "全选",
        "RenewalRenting": "退租/续租",
        "exportstudentcardinformation": "导出学生卡信息",
        "batchcheck-in": "批量入住",
        "batchcheckExport": "批量导入",
        "compareuploads": "对比上传",
        "switchboxdisplay": "切换方块展示",
        "SwitchTableDisplay": "切换表格展示",
        "AdvancedQuery": "高级查询",
        "AdvancedSearch": "高级搜索",
        "ResetSearch": "重置搜索",
        "Adddevice": "添加设备",
        "BatchAdd": "批量添加",
        "Batchinitialization": "批量初始化",
        "ExportList": "导出列表",
        "Synchronizedeviceinformation": "同步设备信息",
        "UnbindRoom": "解绑房间",
        "Forceddeletion": "强制删除",
        "Save": "保存",
        "renewaloflease": "续租",
        "submit": "提交",
        "SameUseQuery": "同用查询",
        "synchronize": "同步时间"
    },
    menubar: {
        "datasummary": "数据汇总",
        "homepage": "首页",
        "Largescreendisplay": "大屏展示",
        "PropertyManagement": "房源管理",
          "Repair": "报修管理",
        "Listingofproperties": "房源列表",
        "BusinessManagement": "业务管理",
        "Doorlockbusiness": "门锁业务",
        "Checkinprocessing": "入住办理",
        "Residencymanagement": "退住管理",
        "Survivalmanagement": "续住管理",
        "personnelmanagement": "人员管理",
        "PersonnelList": "人员列表",
        "VoucherManagement": "凭证管理",
        "InformationBase": "信息库",
        "equipmentmanagement": "设备管理",
        "Doorlockequipment": "门锁设备",
        "Doormagneticequipment": "门磁设备",
        "Usermanagement": "用户管理",
        "Loginaccount": "登录账号",
        "Rolepermissions": "角色权限",
        "bindarole": "绑定角色",
        "Logmanagement": "日志管理",
        "Systemlogs": "系统日志",
        "Doorlocklog": "门锁日志",
        "UnlockRecord": '开锁记录',
        "WarningLog": "警告日志",
        "DeviceFeedbackLog": "设备反馈日志",
        "Doormagneticlog": "门磁日志",
        "Alarmlog": "报警日志"
    },
    enmonth: {
        "Jan": "1月",
        "Feb": "2月",
        "Mar": "3月",
        "Apr": "4月",
        "May": "5月",
        "Jun": "6月",
        "Jul": "7月",
        "Aug": "8月",
        "Sep": "9月",
        "Oct": "10月",
        "Nov": "11月",
        "Dec": "12月",
    },
    singlePrice:{
        priceName:'价格名称',
        priceNum:'价格编号',
        status:'状态',
        type:'类型',
        price:'价格',
        waterPrice:'水价/m³',
        electricityPrice:'电价/KW',
        waterPriceType:'收费类型/水价',
        electricityPriceType:'收费类型/电价'
    }
}



// WEBPACK FOOTER //
// ./src/utils/zh.js